import { useSearchParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function FirebaseActionHandler() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const mode = searchParams.get('mode');
    const oobCode = searchParams.get('oobCode');

    if (!mode || !oobCode) {
      navigate('/error'); // or show a fallback message
      return;
    }

    switch (mode) {
      case 'resetPassword':
        navigate(`/reset-password?${searchParams.toString()}`);
        break;
      case 'verifyEmail':
        navigate(`/verify-email?${searchParams.toString()}`);
        break;
      default:
        navigate('/error');
        break;
    }
  }, [searchParams, navigate]);

  return <p>Loading...</p>;
}